import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import {
  ConverterService,
  GlobalMessageService,
  GlobalMessageType,
  OccEndpointsService,
  OccProductSearchAdapter,
  SearchConfig,
  ProductSearchPage
} from '@spartacus/core'
import { Observable, of } from 'rxjs'
import { catchError, tap } from 'rxjs/operators'
import { EB_PRODUCT_SEARCH_PAGE_NORMALIZER } from '../../converters/converters'

@Injectable({ providedIn: 'root' })
export class EbProductSearchAdapter extends OccProductSearchAdapter {
  constructor(
    protected http: HttpClient,
    protected occEndpoints: OccEndpointsService,
    protected converter: ConverterService,
    protected globalMessageService: GlobalMessageService
  ) {
    super(http, occEndpoints, converter)
  }

  search(
    query: string,
    searchConfig: SearchConfig = {
      pageSize: 20
    }
  ): Observable<ProductSearchPage> {
    const endpoint = this.occEndpoints.buildUrl('productSearch', {
      queryParams: { query, ...searchConfig }
    })
    return this.http.get(endpoint).pipe(
      this.converter.pipeable(EB_PRODUCT_SEARCH_PAGE_NORMALIZER),
      catchError(error => {
        this.displayAnyErrorMessage(error)
        return of({})
      }),
      tap((result: any) => {
        const error = result?.errors?.[0]
        this.displayAnyErrorMessage(error)
      })
    )
  }

  protected displayAnyErrorMessage(error) {
    if (error?.message) {
      this.globalMessageService.add(
        {
          key: 'productGrid.error',
          params: error
        },
        GlobalMessageType.MSG_TYPE_ERROR
      )
    }
  }
}
